import styled from "styled-components";

export const InfoContainer = styled.div`
	display: flex;
	justify-content: ${(props) =>
		props.desktop && !props.virtualRoom ? "space-between" : "center"};
	width: 100%;
	div {
		display: flex;
		flex-direction: column;
		padding: 1rem;
		text-align: center;
	}

	span {
		width: 60%;
		display: flex;
		justify-content: space-evenly;
		align-self: center;
		align-items: flex-end;
		margin-bottom: 0.5rem;
		font-weight: 600;
		color: #0050b3;
		font-size: ${(props) => (props.desktop ? "24px" : "1.1rem")};
		span {
			width: 65%;
			font-size: 1.2rem;
			margin: 0;
		}
	}

	p {
		margin-bottom: 0;
	}
	.info-container {
		width: 100%;
	}
`;
